<template>
  <div>
    <div class="categories-wrapper__none-module" :style="isUpdate && 'margin-top: 2rem'">
      <new-module
        :selected="noneModulesSelected"
        title="Create an event with a basic registration form"
        description="The form allows participants to fill in their name, email address, and phone number. Additional fields can be added based on the organizer's preferences, offering flexibility to customize the form according to specific needs."
        disabled
      />
    </div>
    <div class="event-extra-modules-container">
      <h2 class="form-title">{{ isUpdate ? 'Optional modules' : 'Or choose optional modules' }}</h2>
      <div class="categories-wrapper">
        <new-module
          :selected="form.modules.ticketing"
          title="Tickets"
          description="Enabling tickets gives you the opportunity to sell tickets to your attendees."
          :disabled="disableEditing"
          @click="toggleModule('ticketing')"
        >
          <div v-if="form.modules.ticketing">
            <new-module
              v-if="!isSportOrganization()"
              submodule
              :selected="form.modules.floorPlan"
              title="FLOOR PLAN"
              description="Enabling the floor plan allows you to have multiple sections in your venue for multiple ticket types."
              optional
              :disabled="disableEditing"
              @click="toggleModule('floorPlan')"
            />
            <!--     uncomment this when adding ticket personalization feature     -->
            <!--          <new-module
              submodule
              :selected="form.modules.ticketPersonalization"
              title="TICKET PERSONALIZATION"
              description="Process of assigning each ticket to a specific individual, often requiring personal details like name or ID, to ensure security and prevent unauthorized transfers — for example, festivals often mandate that each ticket displays the attendee's name for entry."
              optional
              :disabled='disableEditing'
              @click="toggleModule('ticketPersonalization')"
            />-->
          </div>
        </new-module>
        <new-module
          v-if="!isSportOrganization()"
          :selected="form.modules.categoriesAndZones"
          title="Categories & zones"
          description="If you're managing a major event, you can enable accreditation categories and zones to control venue access privileges."
          :disabled="disableEditing"
          @click="toggleModule('categoriesAndZones')"
        />
        <new-module
          :selected="form.modules.workshops"
          title="Workshops"
          description="Enable this module to empower your attendees by registering to multiple workshops hosted at your event."
          :disabled="disableEditing"
          @click="toggleModule('workshops')"
        />
        <new-module
          v-if="!isSportOrganization()"
          :selected="form.modules.mobileApp"
          title="Mobile app"
          description="By enabling mobile app, your attendees can easily access info about your event and find new connections at site."
          :disabled="disableEditing"
          @click="toggleModule('mobileApp')"
        >
          <div v-if="form.modules.mobileApp">
            <new-module
              :selected="form.modules.conferenceMobileApp"
              submodule
              title="CONFERENCE MOBILE APP"
              description="By enabling this app, your attendees can easily access info about your event, find new connections at the site, and arrange meetings."
              :disabled="disableEditing"
              @click="toggleModule('conferenceMobileApp')"
            />
            <new-module
              :selected="form.modules.expoMobileApp"
              submodule
              title="EXPO MOBILE APP"
              description="Designed for exhibitors at trade shows to easily track visitors to their booths. By scanning a visitor's QR code with a mobile device, exhibitors can quickly record attendance and gather essential contact information."
              :disabled="disableEditing"
              @click="toggleModule('expoMobileApp')"
            />
          </div>
        </new-module>
      </div>
      <div v-if="!isUpdate" class="buttons-wrapper">
        <main-button text="CANCEL" flat depressed @click="goBack()" />
        <div class="buttons">
          <main-button flat outline @click="() => this.$emit('back')">
            <v-icon class="arrow-back">arrow_back</v-icon>
            <span>back</span>
          </main-button>
          <main-button text="CREATE EVENT" :disabled="submittingForm" @click="onSubmitClick" />
        </div>
      </div>
      <div v-else class="buttons-wrapper--update">
        <main-button text="UPDATE" @click="onSubmitClick" />
      </div>
      <simple-snackbar v-bind.sync="snackbar" />
    </div>
  </div>
</template>

<script>
import newModule from './new-module.vue'
import SimpleSnackbar from '@/components/shared/snackbars/simple-snackbar.vue'

export default {
  name: 'event-extra-modules',
  components: {
    SimpleSnackbar,
    newModule,
  },
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    disableEditing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: this.initialValues,
      snackbar: null,
      isUpdate: !this.initialValues.generalInfo,
    }
  },
  computed: {
    noneModulesSelected() {
      return Object.values(this.form.modules).every(value => !value)
    },
  },
  methods: {
    /*toggleModule(name) {
      const modules = this.form.modules
      const disableTicketAndSubcategories = ['categoriesAndZones', 'workshops', 'mobileApp', 'conferenceMobileApp', 'expoMobileApp'].includes(
        name,
      )
      const toggleTicket = name === 'ticketing'
      this.form.modules = {
        ...modules,
        workshops:
          name === 'mobileApp' && !modules['mobileApp']
            ? true
            : !toggleTicket && modules['workshops'],
        mobileApp:
          (name === 'workshops' && modules['workshops']) || toggleTicket
            ? false
            : modules['mobileApp'],
        ticketing: disableTicketAndSubcategories ? false : modules.ticketing,
        categoriesAndZones: toggleTicket ? false : modules.categoriesAndZones,
        floorPlan:
          modules.ticketing === false || disableTicketAndSubcategories ? false : modules.floorPlan,
        // uncomment this line when adding ticket personalization feature
        // ticketPersonalization: modules.ticketing === false || disableTicketAndSubcategories ? false : modules.ticketPersonalization,
        conferenceMobileApp: (name === 'workshops' && modules['workshops']) || !modules.mobileApp || toggleTicket ? false : modules.conferenceMobileApp,
        expoMobileApp: (name === 'workshops' && modules['workshops']) || !modules.mobileApp || toggleTicket ? false : modules.expoMobileApp,
        [name]: !modules[name],
      }
    },*/
    toggleModule(name) {
      const newFormModules = { ...this.form.modules, [name]: !this.form.modules[name] }
      const toggledValue = newFormModules[name]
      if (name === 'ticketing' && toggledValue) {
        newFormModules.categoriesAndZones = false
        newFormModules.workshops = false
        newFormModules.mobileApp = false
        newFormModules.conferenceMobileApp = false
        newFormModules.expoMobileApp = false
      } else if (name === 'ticketing' && !toggledValue) {
        this.unselectTicketingSubmodules(newFormModules)
      } else if (name === 'categoriesAndZones' && toggledValue) {
        this.unselectTicketingAndTicketingSubmodules(newFormModules)
      } else if (name === 'workshops' && toggledValue) {
        this.unselectTicketingAndTicketingSubmodules(newFormModules)
      } else if (name === 'workshops' && !toggledValue) {
        newFormModules.conferenceMobileApp = false
      } else if (name === 'mobileApp' && toggledValue) {
        this.unselectTicketingAndTicketingSubmodules(newFormModules)
      } else if (name === 'mobileApp' && !toggledValue) {
        newFormModules.conferenceMobileApp = false
        newFormModules.expoMobileApp = false
      } else if (name === 'conferenceMobileApp' && toggledValue) {
        newFormModules.workshops = true
        newFormModules.expoMobileApp = false
      } else if (name === 'expoMobileApp' && toggledValue) {
        newFormModules.conferenceMobileApp = false
      }

      this.$set(this.form, 'modules', newFormModules)

    },
    unselectTicketingSubmodules(modules) {
      modules.floorPlan = false
      // uncomment this line when adding ticket personalization feature
      // modules.ticketPersonalization = false
    },
    unselectTicketingAndTicketingSubmodules(modules) {
      modules.ticketing = false
      this.unselectTicketingSubmodules(modules)
    },

    isSportOrganization() {
      return this.$route.path.includes('/sport-organizations/')
    },

    onSubmitClick() {
      if (this.form.modules.mobileApp && !this.form.modules.conferenceMobileApp && !this.form.modules.expoMobileApp) {
        this.snackbar = {
          open: true,
          messageProp: 'Please select at least one mobile app',
          color: 'error',
        }

        return
      }

      this.$emit(this.isUpdate ? 'update' : 'submit')
    },
  },
}
</script>

<style scoped>
.event-extra-modules-container {
  margin-top: 3rem;
}
.categories-wrapper {
  margin: 0.5rem 0 1.5rem 0;
  border-radius: 0.5rem;
  border: 1px solid #D9D9D9;
  overflow: hidden;
}
.categories-wrapper__none-module {
  border-radius: 0.5rem;
  border: 1px solid #D9D9D9;
  overflow: hidden;
  margin-top: 5.38rem;
}
.categories-wrapper > *:not(:first-child) {
  border-top: 1px solid #D9D9D9;
}
.buttons-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.title {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1.125rem;
  color: #ff4c00;
}
.description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  color: #979797;
}
.inputs {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1rem;
  row-gap: 0.5rem;
}
.text-field {
  flex-basis: 45%;
}
.vat-text {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1.125rem;
  margin-top: 1.5rem;
  color: #333333;
}
.radio-item {
  display: inline-block;
  position: relative;
  padding: 0 0.375rem;
  margin: 0.625rem 0 0;
}

.radio-item input[type='radio'] {
  display: none;
}

.radio-item label {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1.125rem;
  color: #979797;
}

.radio-item label:before {
  content: ' ';
  display: inline-block;
  position: relative;
  top: 0.313rem;
  margin: 0 0.313rem 0 0;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 0.688rem;
  border: 0.125rem solid #666666;
  background-color: transparent;
}

.radio-item input[type='radio']:checked + label:after {
  border-radius: 0.688rem;
  width: 0.75rem;
  height: 0.75rem;
  position: absolute;
  top: 0.563rem;
  left: 0.625rem;
  content: ' ';
  display: block;
  background: #0277bd;
}
@media screen and (max-width: 444px) {
  .buttons-wrapper {
    flex-direction: column-reverse;
  }
  .buttons {
    display: flex;
    flex-direction: column-reverse;
  }
}
@media screen and (max-width: 600px) {
  .inputs {
    display: flex;
    flex-direction: column;
    row-gap: 0.75rem;
  }
}
.arrow-back {
  margin-right: 0.625rem;
}
.form-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #ff4c00;
}
.finance-info {
  padding: 0 3.5rem 2rem;
}
.buttons-wrapper--update {
  display: flex;
  justify-content: flex-end;
}
</style>
